import React, { Component } from "react";
import TimeDisplay from './TimeDisplay.js';
import BoatControl from './BoatControl.js';
import BoatInfo from './BoatInfo.js';
import '../css/bottomLeft_UI.css';
import 'tippy.js/dist/tippy.css';

class BottomLeftUI extends Component {
    constructor(props) {
        super(props);
        this.desiredBearingInput = this.desiredBearingInput.bind(this);
        this.desiredBearingChange = this.desiredBearingChange.bind(this);

        this.state = {
            desiredBearing: 0,
            bearingIsChanging: false,
        }
    }

    render() {
        return (
            <div id="bottomLeft_UI">
                <TimeDisplay
                    boatData={this.props.boatData}
                />
                <BoatControl
                    boatData={this.props.boatData}
                    desiredBearingInput={this.desiredBearingInput}
                    desiredBearingChange={this.desiredBearingChange}
                />
                <BoatInfo
                    boatData={this.props.boatData}
                    desiredBearing={this.state.desiredBearing}
                    bearingIsChanging={this.state.bearingIsChanging}
                />
            </div>
        );
    }

    desiredBearingInput(value) {
        this.setState({ desiredBearing: value, bearingIsChanging: true });
    }
    desiredBearingChange(value) {
        this.setState({ desiredBearing: value, bearingIsChanging: false });
        this.props.desiredBearingChange(value);
    }
}


export default BottomLeftUI;
